import { Middleware, AnyAction } from '@reduxjs/toolkit';

const loggerMiddleware: Middleware = store => next => (action: unknown) => {
  const actionObj = action as AnyAction;
  if (!actionObj?.type) {
    console.warn('Warning: action has no type:', action);
    return;
  }

  try {
    // Call next middleware/reducer
    const result = next(action);

    // Log the new state
    /*
    console.log({
      actionObj
    });
    */

    return result;
  } catch (e) {
    console.error('Error in dispatching action:', {
      error: e,
      action: actionObj
    });
  }
};

export default loggerMiddleware;